import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints'

const { availableOperatorsUrl, userAssigned } = config.endpoints.assignation

/**
 * Get available operators
 *
 * @param {Object} [params]
 * @param {[string]} params.brands
 * @param {[string]} params.delegations
 * @param {[string]} params.roles
 * @param {string} params.text
 * @param {number} params.from
 * @param {number} params.size
 * @param {boolean} [params.getFilters]
 */
const getAvailableOperators = function (params = {}) {
  return axios({
    url: availableOperatorsUrl,
    headers: getHeaders(true),
    params,
  }).catch(({ response = {}, message }) => {
    const { data } = response

    throw data || message
  })
}

const getUsersAssigned = (data) => axios({
  method: 'post',
  url: userAssigned,
  data,
  headers: getHeaders(true),
})


export default {
  getAvailableOperators,
  getUsersAssigned
}
